import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { defineResponsiveGridColumns } from '@utils/utils';
interface CookiebotManagerProps {
  className?: string;
}

const CookiebotManager: React.FC<CookiebotManagerProps> = ({ className }) => {
  const scriptRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const scriptId = 'CookieDeclaration';

    // Check if the script already exists
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://consent.cookiebot.com/${process.env.GATSBY_COOKIE_BOT_ID}/cd.js`;
      script.type = 'text/javascript';

      const currentRef = scriptRef.current;
      currentRef?.appendChild(script);

      return () => {
        currentRef?.removeChild(script);
      };
    }
  }, []);

  return (
    <div className={className}>
      <div className="grid-wrapper">
        <div ref={scriptRef} className="cookiebot-container"></div>
      </div>
    </div>
  );
};

const StyledCookiebotManager = styled(CookiebotManager)`
  .grid-wrapper {
    display: grid;
    column-gap: ${vars.mobileColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(4)};

    .cookiebot-container {
      grid-column: col1-start / col4-end;
      ${vars.fontSize5}
      margin: ${vars.spacingM} 0;
      line-height: 1.6;
      letter-spacing: -0.02em;
      &:last-of-type {
        padding-bottom: 0;
      }
    }

    @media screen and (min-width: ${vars.breakPointTablet}) {
      column-gap: ${vars.standardColumnPercentageGap};
      grid-template-columns: ${defineResponsiveGridColumns(8)};
      .cookiebot-container {
        grid-column: col2-start / col7-end;
      }
    }

    @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
      column-gap: ${vars.standardColumnPercentageGap};
      grid-template-columns: ${defineResponsiveGridColumns(12)};
      .cookiebot-container {
        grid-column: col3-start / col10-end;
      }
    }
  }
`;

export default StyledCookiebotManager;
